export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/portraits_caricatures.7092407.svg";